import * as $ from 'jquery';
import Sortable from 'sortablejs';

(function () {
    Sortable.prototype._onTapStartFixed = Sortable.prototype._onTapStart;
    Sortable.prototype._onTapStart = function(evt) {
        var sender = (evt && evt.target) || (window.event && window.event.srcElement);
        return (sender.nodeName !== 'INPUT') ? this._onTapStartFixed(evt) : null;
    }
})();

$(document).on('show.bs.dropdown', function (event) {
    $('.dropdown-backdrop').off().remove();
});